let infoButtons = document.querySelector('.product-info__block .product-info__add-button');
let shopifyPaymentButton = document.querySelector('.product-info__block .shopify-payment-button');
let stockStatusEl = document.querySelector('.product-info .pdp-stock-status');
let etaDate = document.querySelector('.product-eta-metafield');
let isAvailable = document.querySelector('.product-is_available');
let stockStatus = document.querySelector('.product-stock_status');
let stockQty = document.querySelector('.product-qty');
let pCollectionType = document.querySelector('#p-collection-type');
let buttonBuyTranslate = 'buy it now';
let isPreorderStockUpdated = false;
let productInfo = document.querySelectorAll('.disclosure--row');
if(productInfo.length >= 2){
  let productSpecifications = productInfo[1];
  let specificationsContent = productSpecifications.querySelector('.disclosure__content');
  let contentFields = specificationsContent.querySelectorAll('p');
  let hasContent = false;
  
  // Hide product specifications when fields have no value
  contentFields.forEach((contentField) => {
    let cloneContentField = contentField.cloneNode(true);
    cloneContentField.removeChild(cloneContentField.firstChild);
    if (cloneContentField.innerHTML.trim().length > 0) {
      hasContent = true;
      return;
    }
    contentField.style.display = 'none';
  });
  if (!hasContent) {
    productSpecifications.style.display = 'none';
  }
}

let productRatingReview = document.querySelector('.shopify-app-block[id*="yotpo_product_reviews_ugc_star"]');

if (productRatingReview) {
    window.addEventListener("load", (event) => {
      productRatingReview.classList.add('widget-loaded')
    })
}

if (stockStatus && stockStatus.textContent.trim() == 'Subscription') {
    buttonBuyTranslate = 'Subscribe Now'
    subscriptionButtonChange()
}

let preOrderMessage = 'Pre-Order Today';
if (stockQty && stockQty.textContent.trim() <= 0) {
    preOrderMessage = 'Pre-order Allocation Exhausted';
} else if (etaDate && etaDate.textContent.trim()) {
  preOrderMessage = 'Pre-Order Today - expected ' + etaDate.textContent.trim();
}


if (stockStatusEl) {
    let stockLevel = stockStatusEl.getAttribute("data-inventory-label");

    if (shopifyPaymentButton.querySelector('.shopify-payment-button__button--unbranded')) {
        let button = shopifyPaymentButton.querySelector('.shopify-payment-button__button--unbranded');
        if (button) {
            button.innerText = buttonBuyTranslate;
        }
    }
    if (isAvailable && isAvailable.textContent.trim() == 2 && stockStatus && stockStatus.textContent.trim() == 'Pre order') {
      preOrderBuyNowChange();
    }
  
    // Options for the observer (which mutations to observe)
    const configPaymentButton = { childList: true, subtree: true };
    const observerPaymentButton = new MutationObserver(callbackPaymentButton).observe(shopifyPaymentButton, configPaymentButton);
}


function callbackPaymentButton(mutationList, observer) {
    for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
            console.log('A child node has been added or removed.');
            if (shopifyPaymentButton.querySelector('.shopify-payment-button__button--branded')) {
                let button = shopifyPaymentButton.querySelector('.shopify-cleanslate [role="button"]');
                if (button) {
                    button.innerHTML = '<p>' + buttonBuyTranslate + '</p>';
                    observer.disconnect();
                }
            }
        }
    }
}

function subscriptionButtonChange() {
    var observePreorderBtn = setInterval(function () {
        let buttonSubscription = document.querySelector('[data-testid="ShopifyPay-button"]');
        if (buttonSubscription) {
            buttonSubscription.innerHTML = '<p>' + buttonBuyTranslate + '</p>';
        }
        }, 1000);

    setTimeout(function () {
        clearInterval(observePreorderBtn);
    }, 10000);
    // change unbranded button text
    if (shopifyPaymentButton.querySelector('.shopify-payment-button__button--unbranded')) {
        let button = shopifyPaymentButton.querySelector('.shopify-payment-button__button--unbranded');
        if (button) {
            button.innerText = buttonBuyTranslate;
        }
    }
}

function preOrderBuyNowChange() {
    var observePreorderBtn = setInterval(function () {
        //if (document.querySelector('.product-info .product-info__add-button .gPreorderBtn')) {
            if (document.querySelector('.shopify-payment-button__button--branded')) {
                let button = document.querySelector('.shopify-payment-button__button--branded .shopify-cleanslate [role="button"]');
                if (button) {
                    button.innerHTML = '<p>Pre Order Now</p>';
                    if (stockQty && stockQty.textContent.trim() <= 0) {
                        button.classList.add("inactive");
                    }
                    //observer.disconnect();
                }
            }

            if (document.querySelector('.shopify-payment-button__button--unbranded')) {
                let button = document.querySelector('.shopify-payment-button__button--unbranded');
                if (button.innerText !== 'Pre Order Now') {
                    button.innerText = 'Pre Order Now';
                    if (stockQty && stockQty.textContent.trim() <= 0) {
                        button.classList.add("inactive");      
                    }
                }
            }
            // Render stock status
            if (!isPreorderStockUpdated) {
                document.querySelector('.pdp-stock-status').innerHTML = '<div class="icon"></div> <div class="stock-text"><b>' + preOrderMessage +'</b></div>';
                document.querySelector('.pdp-stock-status').setAttribute('data-inventory-label', 'preorder');
                isPreorderStockUpdated = true;
            }
        //}
    }, 100);

    setTimeout(function () {
        clearInterval(observePreorderBtn);
    }, 10000);
}